import React from "react";
import LegalLayout from "./LegalLayout";
import { Download } from "lucide-react";

const RECESSO_PDF_URL = "/api/uploads/modulo-di-recesso-leovera.pdf";

const ModuloRecesso = () => (
  <LegalLayout
    testid="page-modulo-recesso"
    eyebrow="Documento legale"
    title="Modulo di Recesso"
    updated="Ottobre 2026"
  >
    <p>
      Ai sensi dell'Allegato I, parte B del D.lgs. 206/2005 ("Codice del Consumo"), il Cliente
      consumatore che desidera esercitare il proprio diritto di recesso entro 14 giorni dalla
      ricezione dei prodotti può compilare e inviare il presente modulo tipo (facoltativo, ma
      consigliato) a <strong>info@leoveranutrition.it</strong> oppure via PEC a{" "}
      <strong>d.allibriopec@pec.it</strong>.
    </p>

    <p className="not-prose mb-6">
      <a href="/recesso" data-testid="modulo-recesso-online-link" className="inline-flex items-center gap-2 text-[#C0C0C0] hover:text-white transition-colors">
        → Preferisci farlo online? Recedi dal contratto qui
      </a>
    </p>

    <a
      href={RECESSO_PDF_URL}
      download="Modulo-di-Recesso-LEOVERA.pdf"
      data-testid="recesso-download-btn"
      style={{ color: "#060A14" }}
      className="inline-flex items-center gap-3 mt-2 bg-[#C0C0C0] px-6 py-3.5 rounded-sm text-[11px] tracking-[0.28em] uppercase hover:bg-white transition-colors no-underline"
    >
      <Download className="w-4 h-4" />
      Scarica il modulo PDF
    </a>

    <h2>Destinatario</h2>
    <p>
      LEOVERA Nutrition di Davide Allibrio, P.IVA 02155960897, REA SR-472359.
      <br />
      Sede legale: Viale Tunisi 68, Siracusa (SR).
      <br />
      PEC: d.allibriopec@pec.it &middot; Email: info@leoveranutrition.it
    </p>

    <h2>Notifica di recesso</h2>
    <p>
      Con la presente io/noi notifichiamo il recesso dal mio/nostro contratto di vendita dei
      seguenti beni:
    </p>
    <ul>
      <li>Numero d'ordine: ______________________</li>
      <li>Prodotto/i: ______________________</li>
      <li>Ordinato il: ______________________ &middot; Ricevuto il: ______________________</li>
      <li>Nome del consumatore: ______________________</li>
      <li>Indirizzo del consumatore: ______________________</li>
      <li>IBAN per il rimborso: ______________________</li>
      <li>
        Firma del consumatore <i>(solo se notificato in versione cartacea)</i>: ______________________
      </li>
      <li>Data: ______________________</li>
    </ul>

    <h2>Condizioni</h2>
    <p>
      I prodotti dovranno essere restituiti integri, nella confezione originale sigillata, entro
      14 giorni dalla comunicazione di recesso. Ai sensi dell'art. 59 lett. e) del Codice del
      Consumo, il diritto di recesso <strong>non si applica</strong> a prodotti sigillati che sono
      stati aperti dopo la consegna per motivi igienici o connessi alla protezione della salute.
      Per i dettagli completi consulta i{" "}
      <a href="/termini">Termini e Condizioni di Vendita</a>.
    </p>
    <p>
      <strong>Prodotti danneggiati, con sigillo rotto o non conformi.</strong> L'apertura del
      sigillo per verificare il prodotto alla consegna non pregiudica la garanzia legale di
      conformità, che resta valida per 24 mesi dalla consegna ai sensi degli artt. 128-135 del
      Codice del Consumo: in presenza di un difetto di conformità già esistente al momento della
      consegna, il Cliente deve denunciarlo entro 2 mesi dalla scoperta e ha diritto, a sua scelta
      e senza spese, alla riparazione o alla sostituzione del prodotto, salvo che il rimedio
      richiesto sia impossibile o eccessivamente oneroso; in mancanza, può richiedere una
      riduzione del prezzo o la risoluzione del contratto. Diversamente, ai sensi dell'art. 59,
      lett. e) del Codice del Consumo, il diritto di recesso non si applica ai prodotti sigillati,
      per motivi igienici o di protezione della salute, una volta aperti dopo la consegna. In caso
      di prodotti arrivati danneggiati durante il trasporto, il Cliente è invitato a segnalarlo
      entro 48 ore dalla consegna scrivendo a <strong>info@leoveranutrition.it</strong> con foto
      del prodotto e dell'imballaggio, per consentirci di avviare la sostituzione o il rimborso nel
      più breve tempo possibile.
    </p>
  </LegalLayout>
);

export default ModuloRecesso;
